import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import AppNavigate from '../../../components/reusable/app-navigate/AppNavigate';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import withRouter from '../../../hoc/with-router';
import { Paths } from '../../../shared/paths';
import { useStyles } from './ProgramCollection.styles';
import ProgramCollectionDetails from './ProgramCollectionDetails/ProgramCollectionDetails';
import ProgramCollectionItems from './ProgramCollectionItems/ProgramCollectionItems';

function ProgramCollection(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();

  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { navigate, back } = useNavigationStack();

  const tabsConfig = useMemo(
    () => [
      {
        label: t('programs.details'),
        path: Paths.programs.toViewCollectionDetailsId(params.programId),
      },
      {
        label: t('programs.items'),
        path: Paths.programs.toViewCollectionItemsId(params.programId),
      },
    ],
    [i18n.language, params.programId],
  );

  return (
    <PageContainer title={t('programs.programCollection')} backButton>
      <AppTabs config={tabsConfig} />

      <Routes>
        <Route
          path={Paths.programs.details}
          element={<ProgramCollectionDetails programId={params.programId} />}
        />
        <Route
          path={Paths.programs.items}
          element={<ProgramCollectionItems programId={params.programId} />}
        />
        <Route
          path={'*'}
          element={
            <AppNavigate
              to={Paths.programs.toViewCollectionDetailsId(params.programId)}
              replace
            />
          }
        />
      </Routes>
    </PageContainer>
  );
}

export default withRouter(ProgramCollection);
